// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154iidpf{top:0}\n._18m91wug{overflow-y:auto}\n._1ltvidpf{left:0}\n._1reo1wug{overflow-x:auto}\n._1xi2idpf{right:0}\n._4t3i8ved{height:75px}\n._94n5idpf{bottom:0}\n._bfhk15j7{background-color:var(--ds-surface,#f4f5f7)}\n._bfhk1nox{background-color:#1d2125}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
